export enum UserLinkTypeEnum {
    SERVICE_PERSON_CONTACT = 'personContact',
    ORGANIZATION_PERSON_CONTACT = 'organizationPerson',
}
